<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表（小规模纳税人适用）附列资料（一）</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody>
          <tr>
            <td colspan="4">
              <b>应税行为（3%征收率）扣除额计算</b>
            </td>
          </tr>
          <tr>
            <td>期初余额</td>
            <td>本期发生额</td>
            <td>本期扣除额</td>
            <td>期末余额</td>
          </tr>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>3（3≤1＋2之和，且3≤5）</td>
            <td>4＝1＋2－3</td>
          </tr>
          <tr>
            <td>
              <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: center">
              <b>应税行为（3%征收率）计税销售额计算</b>
            </td>
          </tr>
          <tr>
            <td>全部含税收入（适用3%征收率）</td>
            <td>本期扣除额</td>
            <td>含税销售额</td>
            <td>不含税销售额</td>
          </tr>
          <tr>
            <td>5</td>
            <td>6=3</td>
            <td>7=5-6</td>
            <td>8＝7÷1.03</td>
          </tr>
          <tr>
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x2.value) }}</td>
            <td>{{ parseFloatNum(data.v2x3.value) }}</td>
            <td>{{ parseFloatNum(data.v2x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <b>应税行为（5%征收率）扣除额计算</b>
            </td>
          </tr>
          <tr>
            <td class="td_align">期初余额</td>
            <td class="td_align">本期发生额</td>
            <td class="td_align">本期扣除额</td>
            <td class="td_align">期末余额</td>
          </tr>
          <tr>
            <td class="td_align">9</td>
            <td class="td_align">10</td>
            <td class="td_align">11（11≤9＋10之和，且11≤13）</td>
            <td class="td_align">12＝9＋10－11</td>
          </tr>
          <tr>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <b>应税行为（5%征收率）计税销售额计算</b>
            </td>
          </tr>
          <tr>
            <td>全部含税收入（适用5%征收率）</td>
            <td>本期扣除额</td>
            <td>含税销售额</td>
            <td>不含税销售额</td>
          </tr>
          <tr>
            <td>13</td>
            <td>14=11</td>
            <td>15＝13－14</td>
            <td>16＝15÷1.05</td>
          </tr>
          <tr>
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x2.value) }}</td>
            <td>{{ parseFloatNum(data.v4x3.value) }}</td>
            <td>{{ parseFloatNum(data.v4x4.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        data.value.v1x4.value = new Big(data.value.v1x1.value).plus(data.value.v1x2.value).minus(data.value.v1x3.value).round(2).toNumber();
        data.value.v2x2.value = data.value.v1x3.value;
        data.value.v2x3.value = new Big(data.value.v2x1.value).minus(data.value.v2x2.value).round(2).toNumber();
        data.value.v2x4.value = new Big(data.value.v2x3.value).div(1.03).round(2).toNumber();
        data.value.v3x4.value = new Big(data.value.v3x1.value).plus(data.value.v3x2.value).minus(data.value.v3x3.value).round(2).toNumber();
        data.value.v4x2.value = data.value.v3x3.value;
        data.value.v4x3.value = new Big(data.value.v4x1.value).minus(data.value.v4x2.value).round(2).toNumber();
        data.value.v4x4.value = new Big(data.value.v4x3.value).div(1.05).round(2).toNumber();
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table>
  <tbody class="read-mode">
    <tr>
      <td colspan="4" style="text-align: center">
        <div class="type td_height"><b>应税行为（3%征收率）扣除额计算</b></div>
      </td>
    </tr>
    <tr>
      <td class="td_align" style="width: 200px">期初余额</td>
      <td class="td_align" style="width: 200px">本期发生额</td>
      <td class="td_align" style="width: 200px">本期扣除额</td>
      <td class="td_align" style="width: 200px">期末余额</td>
    </tr>
    <tr>
      <td class="td_align">1</td>
      <td class="td_align">2</td>
      <td class="td_align">3（3≤1＋2之和，且3≤5）</td>
      <td class="td_align">4＝1＋2－3</td>
    </tr>
    <tr>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="4" style="text-align: center">
        <div class="type td_height"><b>应税行为（3%征收率）计税销售额计算</b></div>
      </td>
    </tr>
    <tr>
      <td class="td_align">全部含税收入（适用3%征收率）</td>
      <td class="td_align">本期扣除额</td>
      <td class="td_align">含税销售额</td>
      <td class="td_align">不含税销售额</td>
    </tr>
    <tr>
      <td class="td_align">5</td>
      <td class="td_align">6=3</td>
      <td class="td_align">7=5-6</td>
      <td class="td_align">8＝7÷1.03</td>
    </tr>
    <tr>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="4" style="text-align: center">
        <div class="type td_height"><b>应税行为（5%征收率）扣除额计算</b></div>
      </td>
    </tr>
    <tr>
      <td class="td_align" style="width: 200px">期初余额</td>
      <td class="td_align" style="width: 200px">本期发生额</td>
      <td class="td_align" style="width: 200px">本期扣除额</td>
      <td class="td_align" style="width: 200px">期末余额</td>
    </tr>
    <tr>
      <td class="td_align">9</td>
      <td class="td_align">10</td>
      <td class="td_align">11（11≤9＋10之和，且11≤13）</td>
      <td class="td_align">12＝9＋10－11</td>
    </tr>
    <tr>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="4" style="text-align: center">
        <div class="type td_height"><b>应税行为（5%征收率）计税销售额计算</b></div>
      </td>
    </tr>
    <tr>
      <td class="td_align">全部含税收入（适用5%征收率）</td>
      <td class="td_align">本期扣除额</td>
      <td class="td_align">含税销售额</td>
      <td class="td_align">不含税销售额</td>
    </tr>
    <tr>
      <td class="td_align">13</td>
      <td class="td_align">14=11</td>
      <td class="td_align">15＝13－14</td>
      <td class="td_align">16＝15÷1.05</td>
    </tr>
    <tr>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
